'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _H = require('UIComponents/elements/headings/H6');

var _H2 = _interopRequireDefault(_H);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _PerAdditionalUnitSubtext = require('pricing-pages-unified-ui/static/js/components/calculator/PerAdditionalUnitSubtext');

var _PerAdditionalUnitSubtext2 = _interopRequireDefault(_PerAdditionalUnitSubtext);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _ItemConfigsSelectors = require('pricing-pages-unified-ui/selectors/ItemConfigsSelectors');

var _PriceBreakdownRow = require('pricing-pages-unified-ui/components/calculator/PriceBreakdownRow');

var _PriceBreakdownRow2 = _interopRequireDefault(_PriceBreakdownRow);

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

var _merchUtils = require('self-service-api/core/utilities/merchUtils');

var _MerchandiseIdLists = require('self-service-api/constants/MerchandiseIdLists');

var _Terms = require('self-service-api/constants/Terms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MODAL_WIDTH = 600;

var ModalBody = _styledComponents2.default.div.withConfig({
  displayName: 'PriceBreakdownModal__ModalBody'
})(['padding:0 25px 10px 25px;']);

var ModalTitle = _styledComponents2.default.div.withConfig({
  displayName: 'PriceBreakdownModal__ModalTitle'
})(['font-weight:600;font-size:22px;text-align:center;padding-top:40px;padding-bottom:50px;']);

var _getLang = function _getLang(path) {
  return _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.calculator.' + path });
};

var PriceBreakdownModal = function (_React$Component) {
  _inherits(PriceBreakdownModal, _React$Component);

  function PriceBreakdownModal() {
    _classCallCheck(this, PriceBreakdownModal);

    return _possibleConstructorReturn(this, (PriceBreakdownModal.__proto__ || Object.getPrototypeOf(PriceBreakdownModal)).apply(this, arguments));
  }

  _createClass(PriceBreakdownModal, [{
    key: 'getAdditionalUnitPricePerMonth',
    value: function getAdditionalUnitPricePerMonth() {
      var _props = this.props,
          activeMerchId = _props.activeMerchId,
          termId = _props.termId,
          activeCurrencyCode = _props.activeCurrencyCode;

      return _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        !this.props.isGrowthSuite && _react2.default.createElement(_PerAdditionalUnitSubtext2.default, {
          merchId: activeMerchId,
          termId: termId,
          currencyCode: activeCurrencyCode
        })
      );
    }
  }, {
    key: 'getPriceSubtext',
    value: function getPriceSubtext() {
      var activeTerm = this.props.activeTerm;

      return _react2.default.createElement(
        _Small2.default,
        { use: 'help' },
        _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.calculator.priceBreakdown.priceSubtextParentheses.' + activeTerm
        })
      );
    }
  }, {
    key: 'getAdjustedQuantity',
    value: function getAdjustedQuantity(merchId, quantity) {
      if (_MerchandiseIdLists.CONTACT_BASED_MERCHANDISE_IDS.includes(merchId)) {
        return (0, _merchUtils.getAdditionalUnitsQuantityMinusIncluded)(quantity, merchId);
      }

      return quantity;
    }
  }, {
    key: 'getBillingName',
    value: function getBillingName(merchId, quantity) {
      var merchObj = _ImmutableMerchandiseIdMap2.default[merchId];
      var billingNameKey = merchObj.billingNameKey;

      // Note: quantity may not always be used in the billingNameKey string,
      //       but there should always be a quantity we can pass

      return _react2.default.createElement(_FormattedMessage2.default, {
        message: 'pricing-pages.billingNames.' + billingNameKey,
        options: { count: quantity }
      });
    }
  }, {
    key: 'renderRecurringFees',
    value: function renderRecurringFees() {
      var _this2 = this;

      var _props2 = this.props,
          recurringMerchPriceBreakdown = _props2.recurringMerchPriceBreakdown,
          activeCurrencyCode = _props2.activeCurrencyCode,
          isGrowthSuite = _props2.isGrowthSuite;


      return recurringMerchPriceBreakdown.map(function (recurringMerch) {
        if (recurringMerch.calculatedPrice === 0) return null;

        var monthlyPriceObj = recurringMerch.monthly;

        var _monthlyPriceObj$pric = _slicedToArray(monthlyPriceObj.priceBreakdown, 2),
            baseMerch = _monthlyPriceObj$pric[0],
            _monthlyPriceObj$pric2 = _monthlyPriceObj$pric[1],
            additionalUnitMerch = _monthlyPriceObj$pric2 === undefined ? null : _monthlyPriceObj$pric2;

        // Need to adjust quantity bc we only want to display *additional* contacts
        // not *total* contacts


        var adjustedAdditionalUnitQuantity = additionalUnitMerch ? _this2.getAdjustedQuantity(additionalUnitMerch.merchandiseId, additionalUnitMerch.quantity) : null;

        return _react2.default.createElement(
          _react2.default.Fragment,
          { key: baseMerch.merchandiseId },
          _react2.default.createElement(_PriceBreakdownRow2.default, {
            price:
            // want all of the growth suite recurring fees to be full price
            // and then show discount after totaled at the bottom
            isGrowthSuite ? baseMerch.fullPrice : baseMerch.calculatedPrice,
            currencyCode: activeCurrencyCode,
            priceDisclaimer: _this2.getPriceSubtext(),
            text: _this2.getBillingName(baseMerch.merchandiseId, baseMerch.quantity),
            isMonthly: true,
            costPerUnitSubtext: _this2.getAdditionalUnitPricePerMonth()
          }),
          adjustedAdditionalUnitQuantity > 0 && _react2.default.createElement(_PriceBreakdownRow2.default, {
            price: isGrowthSuite ? additionalUnitMerch.fullPrice : additionalUnitMerch.calculatedPrice,
            currencyCode: activeCurrencyCode,
            priceDisclaimer: _this2.getPriceSubtext(),
            text: _this2.getBillingName(additionalUnitMerch.merchandiseId, adjustedAdditionalUnitQuantity),
            isMonthly: true,
            costPerUnitSubtext: _this2.getAdditionalUnitPricePerMonth()
          })
        );
      });
    }
  }, {
    key: 'renderOneTimeFees',
    value: function renderOneTimeFees() {
      var _props3 = this.props,
          activeCurrencyCode = _props3.activeCurrencyCode,
          oneTimeMerchPriceBreakdown = _props3.oneTimeMerchPriceBreakdown;


      if (!oneTimeMerchPriceBreakdown || !oneTimeMerchPriceBreakdown.length) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _H2.default,
          { className: 'text-left m-left-7 m-bottom-0' },
          _getLang('priceBreakdown.oneTimeFees')
        ),
        oneTimeMerchPriceBreakdown.map(function (oneTimeMerch) {
          if (oneTimeMerch.calculatedPrice === 0) return null;

          var merchandiseId = oneTimeMerch.priceBreakdown[0].merchandiseId;
          var billingNameKey = _ImmutableMerchandiseIdMap2.default[merchandiseId].billingNameKey;


          return _react2.default.createElement(
            'div',
            { key: merchandiseId },
            _react2.default.createElement(_PriceBreakdownRow2.default, {
              price: oneTimeMerch.calculatedPrice,
              currencyCode: activeCurrencyCode,
              priceDisclaimer: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.notes.oneTimeFeeParentheses' }),
              text: _react2.default.createElement(_FormattedMessage2.default, {
                message: 'pricing-pages.billingNames.' + billingNameKey
              })
            })
          );
        })
      );
    }
  }, {
    key: 'renderTotalCosts',
    value: function renderTotalCosts() {
      var _props4 = this.props,
          pricingInfo = _props4.pricingInfo,
          activeCurrencyCode = _props4.activeCurrencyCode,
          estimatedCostToGetStarted = _props4.estimatedCostToGetStarted,
          fullCostToGetStarted = _props4.fullCostToGetStarted,
          isGrowthSuite = _props4.isGrowthSuite,
          activeTerm = _props4.activeTerm;

      return _react2.default.createElement(
        'div',
        { style: { width: '100%' } },
        _react2.default.createElement(_PriceBreakdownRow2.default, {
          text: _getLang('priceBreakdown.monthlyCost'),
          price: pricingInfo.monthly.calculatedPrice,
          fullPrice: isGrowthSuite && pricingInfo.monthly.fullPrice,
          currencyCode: activeCurrencyCode,
          isMonthly: true,
          isTotal: true,
          priceDisclaimer: this.getPriceSubtext()
        }),
        activeTerm === _Terms.ANNUAL && _react2.default.createElement(_PriceBreakdownRow2.default, {
          text: _getLang('priceBreakdown.subtotal'),
          price: pricingInfo.annually.calculatedPrice,
          fullPrice: isGrowthSuite && pricingInfo.annually.fullPrice,
          currencyCode: activeCurrencyCode,
          isYearly: true,
          isTotal: true,
          priceDisclaimer: _react2.default.createElement(
            _Small2.default,
            { use: 'help' },
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'pricingPage.calculator.priceBreakdown.priceSubtextParentheses.monthlyX12'
            })
          )
        }),
        _react2.default.createElement(_PriceBreakdownRow2.default, {
          text: _getLang('priceDisplay.estimatedCostText'),
          price: estimatedCostToGetStarted,
          fullPrice: isGrowthSuite && fullCostToGetStarted,
          currencyCode: activeCurrencyCode,
          isTotal: true,
          priceDisclaimer: _react2.default.createElement(
            _Small2.default,
            { use: 'help' },
            _react2.default.createElement(_FormattedMessage2.default, {
              message: 'pricingPage.calculator.priceDisplay.costSubtext.' + activeTerm
            })
          )
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var onCloseClick = this.props.onCloseClick;

      return _react2.default.createElement(
        _UIModal2.default,
        {
          use: 'conversational',
          width: MODAL_WIDTH,
          onOverlayClick: onCloseClick
        },
        _react2.default.createElement(_UIDialogCloseButton2.default, { onClick: onCloseClick }),
        _react2.default.createElement(
          ModalTitle,
          null,
          _getLang('priceBreakdown.modal')
        ),
        _react2.default.createElement(
          ModalBody,
          null,
          _react2.default.createElement(
            _H2.default,
            { className: 'text-left m-left-7 m-bottom-0' },
            _getLang('priceBreakdown.recurringFees')
          ),
          this.renderRecurringFees(),
          this.renderOneTimeFees(),
          _react2.default.createElement(_HR2.default, null),
          this.renderTotalCosts(),
          _react2.default.createElement(
            'div',
            { className: 'p-all-7 text-center' },
            _react2.default.createElement(
              _Small2.default,
              { use: 'help' },
              _getLang('priceBreakdown.footerModal')
            )
          )
        )
      );
    }
  }]);

  return PriceBreakdownModal;
}(_react2.default.Component);

PriceBreakdownModal.propTypes = {
  onCloseClick: _react.PropTypes.func.isRequired,
  pricingInfo: _react.PropTypes.object.isRequired,
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  recurringMerchPriceBreakdown: _react.PropTypes.array.isRequired,
  oneTimeMerchPriceBreakdown: _react.PropTypes.array,
  estimatedCostToGetStarted: _react.PropTypes.number.isRequired,
  fullCostToGetStarted: _react.PropTypes.number,
  activeTerm: _react.PropTypes.string.isRequired,
  activeMerchId: _react.PropTypes.number,
  termId: _react.PropTypes.number.isRequired,
  isGrowthSuite: _react.PropTypes.bool
};

var mapStateToProps = function mapStateToProps(state, _ref) {
  var activeTerm = _ref.activeTerm,
      activeMerchId = _ref.activeMerchId,
      isGrowthSuite = _ref.isGrowthSuite,
      activeEdition = _ref.activeEdition;

  var termId = isGrowthSuite ? _GrowthSuiteEditionTermIdMap2.default[activeEdition][activeTerm] : (0, _ItemConfigsSelectors.termIdFromTermSelector)(state, activeTerm, activeMerchId);

  return {
    termId: termId,
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PriceBreakdownModal);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/PriceBreakdownModal.js
// module id = 594
// module chunks = 3 4